/** Wire limits shared by the desktop capability snapshot and its request schema. */
export const DESKTOP_TERMINAL_HINT_ID_MAX_LENGTH = 64
export const DESKTOP_TERMINAL_HINT_TEXT_MAX_LENGTH = 1024
